/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * KonnectHub REST API Documentation
 * OpenAPI spec version: latest
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionPayload,
  Notification,
  NotificationConnection,
  NotificationCounts,
  NotificationListConnectionParams,
  NotificationMute,
  NotificationMuteConnection,
  NotificationMuteInput,
  NotificationPreferences,
  NotificationPreferencesInput,
  NotificationPrefsMutesParams,
  NotificationReadInput,
  NotificationSettings,
  NotificationSettingsInput
} from '.././model';

import { apiMutator } from '../../client';




/**
 * Registry types × channels, with the mode in force and whether it is an override. Rendered from the registry, so a newly declared type appears here — and in the form — without a client change.
 * @summary The notification preference matrix
 */
export const notificationPrefsPreferences = (
    
 signal?: AbortSignal
) => {
      
      
      return apiMutator<NotificationPreferences>(
      {url: `/api/v1/notifications/preferences`, method: 'GET', signal
    },
      );
    }
  



export const getNotificationPrefsPreferencesQueryKey = () => {
    return [
    `/api/v1/notifications/preferences`
    ] as const;
    }

    
export const getNotificationPrefsPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationPrefsPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationPrefsPreferences>>> = ({ signal }) => notificationPrefsPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationPrefsPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof notificationPrefsPreferences>>>
export type NotificationPrefsPreferencesQueryError = unknown


export function useNotificationPrefsPreferences<TData = Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationPrefsPreferences>>,
          TError,
          Awaited<ReturnType<typeof notificationPrefsPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationPrefsPreferences<TData = Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationPrefsPreferences>>,
          TError,
          Awaited<ReturnType<typeof notificationPrefsPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationPrefsPreferences<TData = Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The notification preference matrix
 */

export function useNotificationPrefsPreferences<TData = Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationPrefsPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A full replace, not a partial update: what arrives IS the matrix, and any cell not named goes back to its registry default. Only cells that differ from a default are stored, which is what keeps a default change a code edit rather than a data migration over every member of every workspace.
 * @summary Replace the notification preference matrix
 */
export const notificationPrefsReplacePreferences = (
    notificationPreferencesInput: NotificationPreferencesInput,
 ) => {
      
      
      return apiMutator<NotificationPreferences>(
      {url: `/api/v1/notifications/preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationPreferencesInput
    },
      );
    }
  


export const getNotificationPrefsReplacePreferencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsReplacePreferences>>, TError,{data: NotificationPreferencesInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsReplacePreferences>>, TError,{data: NotificationPreferencesInput}, TContext> => {

const mutationKey = ['notificationPrefsReplacePreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationPrefsReplacePreferences>>, {data: NotificationPreferencesInput}> = (props) => {
          const {data} = props ?? {};

          return  notificationPrefsReplacePreferences(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationPrefsReplacePreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof notificationPrefsReplacePreferences>>>
    export type NotificationPrefsReplacePreferencesMutationBody = NotificationPreferencesInput
    export type NotificationPrefsReplacePreferencesMutationError = unknown

    /**
 * @summary Replace the notification preference matrix
 */
export const useNotificationPrefsReplacePreferences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsReplacePreferences>>, TError,{data: NotificationPreferencesInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationPrefsReplacePreferences>>,
        TError,
        {data: NotificationPreferencesInput},
        TContext
      > => {

      const mutationOptions = getNotificationPrefsReplacePreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Timezone, digest schedule and quiet hours. Per USER, not per workspace — one human has one sleep schedule while being on-call in one workspace and a spectator in another.
 * @summary Your notification clock
 */
export const notificationPrefsSettings = (
    
 signal?: AbortSignal
) => {
      
      
      return apiMutator<NotificationSettings>(
      {url: `/api/v1/notifications/settings`, method: 'GET', signal
    },
      );
    }
  



export const getNotificationPrefsSettingsQueryKey = () => {
    return [
    `/api/v1/notifications/settings`
    ] as const;
    }

    
export const getNotificationPrefsSettingsQueryOptions = <TData = Awaited<ReturnType<typeof notificationPrefsSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationPrefsSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationPrefsSettings>>> = ({ signal }) => notificationPrefsSettings(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationPrefsSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationPrefsSettings>>>
export type NotificationPrefsSettingsQueryError = unknown


export function useNotificationPrefsSettings<TData = Awaited<ReturnType<typeof notificationPrefsSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationPrefsSettings>>,
          TError,
          Awaited<ReturnType<typeof notificationPrefsSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationPrefsSettings<TData = Awaited<ReturnType<typeof notificationPrefsSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationPrefsSettings>>,
          TError,
          Awaited<ReturnType<typeof notificationPrefsSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationPrefsSettings<TData = Awaited<ReturnType<typeof notificationPrefsSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Your notification clock
 */

export function useNotificationPrefsSettings<TData = Awaited<ReturnType<typeof notificationPrefsSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsSettings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationPrefsSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Partial: `null` on any field means "leave it alone". Turning quiet hours off is `quietEnabled: false`, clearing the timezone is the empty string, and going back to a daily digest is `digestDay: -1`.
 * @summary Update your notification clock
 */
export const notificationPrefsUpdateSettings = (
    notificationSettingsInput: NotificationSettingsInput,
 ) => {
      
      
      return apiMutator<NotificationSettings>(
      {url: `/api/v1/notifications/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: notificationSettingsInput
    },
      );
    }
  


export const getNotificationPrefsUpdateSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsUpdateSettings>>, TError,{data: NotificationSettingsInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsUpdateSettings>>, TError,{data: NotificationSettingsInput}, TContext> => {

const mutationKey = ['notificationPrefsUpdateSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationPrefsUpdateSettings>>, {data: NotificationSettingsInput}> = (props) => {
          const {data} = props ?? {};

          return  notificationPrefsUpdateSettings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationPrefsUpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof notificationPrefsUpdateSettings>>>
    export type NotificationPrefsUpdateSettingsMutationBody = NotificationSettingsInput
    export type NotificationPrefsUpdateSettingsMutationError = unknown

    /**
 * @summary Update your notification clock
 */
export const useNotificationPrefsUpdateSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsUpdateSettings>>, TError,{data: NotificationSettingsInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationPrefsUpdateSettings>>,
        TError,
        {data: NotificationSettingsInput},
        TContext
      > => {

      const mutationOptions = getNotificationPrefsUpdateSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Per USER and per workspace. A mute never suppresses the notification for anyone else — it is a personal filter, which is why an administrator has no way to apply one on your behalf.
 * @summary Resources you have silenced
 */
export const notificationPrefsMutes = (
    params: NotificationPrefsMutesParams,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<NotificationMuteConnection>(
      {url: `/api/v1/notifications/mutes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getNotificationPrefsMutesQueryKey = (params?: NotificationPrefsMutesParams,) => {
    return [
    `/api/v1/notifications/mutes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getNotificationPrefsMutesQueryOptions = <TData = Awaited<ReturnType<typeof notificationPrefsMutes>>, TError = unknown>(params: NotificationPrefsMutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsMutes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationPrefsMutesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationPrefsMutes>>> = ({ signal }) => notificationPrefsMutes(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsMutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationPrefsMutesQueryResult = NonNullable<Awaited<ReturnType<typeof notificationPrefsMutes>>>
export type NotificationPrefsMutesQueryError = unknown


export function useNotificationPrefsMutes<TData = Awaited<ReturnType<typeof notificationPrefsMutes>>, TError = unknown>(
 params: NotificationPrefsMutesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsMutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationPrefsMutes>>,
          TError,
          Awaited<ReturnType<typeof notificationPrefsMutes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationPrefsMutes<TData = Awaited<ReturnType<typeof notificationPrefsMutes>>, TError = unknown>(
 params: NotificationPrefsMutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsMutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationPrefsMutes>>,
          TError,
          Awaited<ReturnType<typeof notificationPrefsMutes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationPrefsMutes<TData = Awaited<ReturnType<typeof notificationPrefsMutes>>, TError = unknown>(
 params: NotificationPrefsMutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsMutes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resources you have silenced
 */

export function useNotificationPrefsMutes<TData = Awaited<ReturnType<typeof notificationPrefsMutes>>, TError = unknown>(
 params: NotificationPrefsMutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPrefsMutes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationPrefsMutesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Idempotent: muting something already muted returns the existing row. Unmuting later reveals FUTURE occurrences only — nothing is backfilled, because the notifications were never written for you in the first place.
 * @summary Silence a flow, deployment or connection
 */
export const notificationPrefsCreateMute = (
    notificationMuteInput: NotificationMuteInput,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<NotificationMute>(
      {url: `/api/v1/notifications/mutes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationMuteInput, signal
    },
      );
    }
  


export const getNotificationPrefsCreateMuteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsCreateMute>>, TError,{data: NotificationMuteInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsCreateMute>>, TError,{data: NotificationMuteInput}, TContext> => {

const mutationKey = ['notificationPrefsCreateMute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationPrefsCreateMute>>, {data: NotificationMuteInput}> = (props) => {
          const {data} = props ?? {};

          return  notificationPrefsCreateMute(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationPrefsCreateMuteMutationResult = NonNullable<Awaited<ReturnType<typeof notificationPrefsCreateMute>>>
    export type NotificationPrefsCreateMuteMutationBody = NotificationMuteInput
    export type NotificationPrefsCreateMuteMutationError = unknown

    /**
 * @summary Silence a flow, deployment or connection
 */
export const useNotificationPrefsCreateMute = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsCreateMute>>, TError,{data: NotificationMuteInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationPrefsCreateMute>>,
        TError,
        {data: NotificationMuteInput},
        TContext
      > => {

      const mutationOptions = getNotificationPrefsCreateMuteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Unmute a resource
 */
export const notificationPrefsRemoveMute = (
    id: unknown,
 ) => {
      
      
      return apiMutator<ActionPayload>(
      {url: `/api/v1/notifications/mutes/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getNotificationPrefsRemoveMuteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsRemoveMute>>, TError,{id: unknown}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsRemoveMute>>, TError,{id: unknown}, TContext> => {

const mutationKey = ['notificationPrefsRemoveMute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationPrefsRemoveMute>>, {id: unknown}> = (props) => {
          const {id} = props ?? {};

          return  notificationPrefsRemoveMute(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationPrefsRemoveMuteMutationResult = NonNullable<Awaited<ReturnType<typeof notificationPrefsRemoveMute>>>
    
    export type NotificationPrefsRemoveMuteMutationError = unknown

    /**
 * @summary Unmute a resource
 */
export const useNotificationPrefsRemoveMute = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationPrefsRemoveMute>>, TError,{id: unknown}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationPrefsRemoveMute>>,
        TError,
        {id: unknown},
        TContext
      > => {

      const mutationOptions = getNotificationPrefsRemoveMuteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Scoped to the active workspace plus your account-level rows (an invitation, a token expiry, being removed from a workspace). Filterable by `read`, `resolved`, `type`, `category` and `urgency`.
 * @summary List your notifications
 */
export const notificationListConnection = (
    params: NotificationListConnectionParams,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<NotificationConnection>(
      {url: `/api/v1/notifications`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getNotificationListConnectionQueryKey = (params?: NotificationListConnectionParams,) => {
    return [
    `/api/v1/notifications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getNotificationListConnectionQueryOptions = <TData = Awaited<ReturnType<typeof notificationListConnection>>, TError = unknown>(params: NotificationListConnectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListConnection>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationListConnectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationListConnection>>> = ({ signal }) => notificationListConnection(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationListConnection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationListConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof notificationListConnection>>>
export type NotificationListConnectionQueryError = unknown


export function useNotificationListConnection<TData = Awaited<ReturnType<typeof notificationListConnection>>, TError = unknown>(
 params: NotificationListConnectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListConnection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationListConnection>>,
          TError,
          Awaited<ReturnType<typeof notificationListConnection>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationListConnection<TData = Awaited<ReturnType<typeof notificationListConnection>>, TError = unknown>(
 params: NotificationListConnectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListConnection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationListConnection>>,
          TError,
          Awaited<ReturnType<typeof notificationListConnection>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationListConnection<TData = Awaited<ReturnType<typeof notificationListConnection>>, TError = unknown>(
 params: NotificationListConnectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListConnection>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List your notifications
 */

export function useNotificationListConnection<TData = Awaited<ReturnType<typeof notificationListConnection>>, TError = unknown>(
 params: NotificationListConnectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationListConnection>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationListConnectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Unread rows are never removed by this.
 * @summary Clear every read notification in scope
 */
export const notificationClearRead = (
    
 ) => {
      
      
      return apiMutator<ActionPayload>(
      {url: `/api/v1/notifications`, method: 'DELETE'
    },
      );
    }
  


export const getNotificationClearReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationClearRead>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationClearRead>>, TError,void, TContext> => {

const mutationKey = ['notificationClearRead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationClearRead>>, void> = () => {
          

          return  notificationClearRead()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationClearReadMutationResult = NonNullable<Awaited<ReturnType<typeof notificationClearRead>>>
    
    export type NotificationClearReadMutationError = unknown

    /**
 * @summary Clear every read notification in scope
 */
export const useNotificationClearRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationClearRead>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationClearRead>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getNotificationClearReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The active workspace, your account-level rows, and a COUNT ONLY for every other workspace with unread rows — no titles, no types, no resources cross the tenancy boundary.
 * @summary Unread counts for the bell badge and the workspace switcher
 */
export const notificationCounts = (
    
 signal?: AbortSignal
) => {
      
      
      return apiMutator<NotificationCounts>(
      {url: `/api/v1/notifications/counts`, method: 'GET', signal
    },
      );
    }
  



export const getNotificationCountsQueryKey = () => {
    return [
    `/api/v1/notifications/counts`
    ] as const;
    }

    
export const getNotificationCountsQueryOptions = <TData = Awaited<ReturnType<typeof notificationCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationCounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationCountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationCounts>>> = ({ signal }) => notificationCounts(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationCountsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationCounts>>>
export type NotificationCountsQueryError = unknown


export function useNotificationCounts<TData = Awaited<ReturnType<typeof notificationCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationCounts>>,
          TError,
          Awaited<ReturnType<typeof notificationCounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationCounts<TData = Awaited<ReturnType<typeof notificationCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationCounts>>,
          TError,
          Awaited<ReturnType<typeof notificationCounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationCounts<TData = Awaited<ReturnType<typeof notificationCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationCounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Unread counts for the bell badge and the workspace switcher
 */

export function useNotificationCounts<TData = Awaited<ReturnType<typeof notificationCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationCounts>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Explicit action only. Opening the notification popover must NOT call this: reading is what cancels a pending email, so a glance at the bell would silence the mail for someone who then forgets.
 * @summary Mark notifications read
 */
export const notificationMarkRead = (
    notificationReadInput: NotificationReadInput,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<ActionPayload>(
      {url: `/api/v1/notifications/read`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationReadInput, signal
    },
      );
    }
  


export const getNotificationMarkReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationMarkRead>>, TError,{data: NotificationReadInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationMarkRead>>, TError,{data: NotificationReadInput}, TContext> => {

const mutationKey = ['notificationMarkRead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationMarkRead>>, {data: NotificationReadInput}> = (props) => {
          const {data} = props ?? {};

          return  notificationMarkRead(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationMarkReadMutationResult = NonNullable<Awaited<ReturnType<typeof notificationMarkRead>>>
    export type NotificationMarkReadMutationBody = NotificationReadInput
    export type NotificationMarkReadMutationError = unknown

    /**
 * @summary Mark notifications read
 */
export const useNotificationMarkRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationMarkRead>>, TError,{data: NotificationReadInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationMarkRead>>,
        TError,
        {data: NotificationReadInput},
        TContext
      > => {

      const mutationOptions = getNotificationMarkReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Emits a real TEST notification through the real pipeline — same fan-out, same preferences, same senders — so what arrives is proof of YOUR configuration rather than of a shortcut. Delivery is asynchronous; the answer here only says it was raised.
 * @summary Send yourself a test notification
 */
export const notificationSendTest = (
    
 signal?: AbortSignal
) => {
      
      
      return apiMutator<ActionPayload>(
      {url: `/api/v1/notifications/test`, method: 'POST', signal
    },
      );
    }
  


export const getNotificationSendTestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationSendTest>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationSendTest>>, TError,void, TContext> => {

const mutationKey = ['notificationSendTest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationSendTest>>, void> = () => {
          

          return  notificationSendTest()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationSendTestMutationResult = NonNullable<Awaited<ReturnType<typeof notificationSendTest>>>
    
    export type NotificationSendTestMutationError = unknown

    /**
 * @summary Send yourself a test notification
 */
export const useNotificationSendTest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationSendTest>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationSendTest>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getNotificationSendTestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Read one notification
 */
export const notificationFindOne = (
    id: unknown,
 signal?: AbortSignal
) => {
      
      
      return apiMutator<Notification>(
      {url: `/api/v1/notifications/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getNotificationFindOneQueryKey = (id?: unknown,) => {
    return [
    `/api/v1/notifications/${id}`
    ] as const;
    }

    
export const getNotificationFindOneQueryOptions = <TData = Awaited<ReturnType<typeof notificationFindOne>>, TError = unknown>(id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationFindOne>>> = ({ signal }) => notificationFindOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof notificationFindOne>>>
export type NotificationFindOneQueryError = unknown


export function useNotificationFindOne<TData = Awaited<ReturnType<typeof notificationFindOne>>, TError = unknown>(
 id: unknown, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationFindOne>>,
          TError,
          Awaited<ReturnType<typeof notificationFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationFindOne<TData = Awaited<ReturnType<typeof notificationFindOne>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationFindOne>>,
          TError,
          Awaited<ReturnType<typeof notificationFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationFindOne<TData = Awaited<ReturnType<typeof notificationFindOne>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one notification
 */

export function useNotificationFindOne<TData = Awaited<ReturnType<typeof notificationFindOne>>, TError = unknown>(
 id: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Dismiss one notification
 */
export const notificationDismiss = (
    id: unknown,
 ) => {
      
      
      return apiMutator<ActionPayload>(
      {url: `/api/v1/notifications/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getNotificationDismissMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationDismiss>>, TError,{id: unknown}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationDismiss>>, TError,{id: unknown}, TContext> => {

const mutationKey = ['notificationDismiss'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationDismiss>>, {id: unknown}> = (props) => {
          const {id} = props ?? {};

          return  notificationDismiss(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationDismissMutationResult = NonNullable<Awaited<ReturnType<typeof notificationDismiss>>>
    
    export type NotificationDismissMutationError = unknown

    /**
 * @summary Dismiss one notification
 */
export const useNotificationDismiss = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationDismiss>>, TError,{id: unknown}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationDismiss>>,
        TError,
        {id: unknown},
        TContext
      > => {

      const mutationOptions = getNotificationDismissMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    